import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import { RequirePermissions } from "@/app/router/guards";
import { PermissionCodes } from "@/shared/auth/permissions";
import { LazyPage } from "@/app/router/LazyPage";

const DemandsListPage = lazy(() =>
  import("@/modules/planning").then((m) => ({ default: m.DemandsListPage })),
);
const DemandDetailPage = lazy(() =>
  import("@/modules/planning").then((m) => ({ default: m.DemandDetailPage })),
);
const ProductionOrdersListPage = lazy(() =>
  import("@/modules/planning").then((m) => ({ default: m.ProductionOrdersListPage })),
);
const ProductionOrderDetailPage = lazy(() =>
  import("@/modules/planning").then((m) => ({
    default: m.ProductionOrderDetailPage,
  })),
);
const MoReservationsPage = lazy(() =>
  import("@/modules/planning").then((m) => ({ default: m.MoReservationsPage })),
);
const ReservationsHubPage = lazy(() =>
  import("@/modules/planning").then((m) => ({ default: m.ReservationsHubPage })),
);

export const planningRoutes: RouteObject[] = [
          {
            element: (
              <RequirePermissions
                codes={[
                  PermissionCodes.PlnDemandList, PermissionCodes.PlnDemandManage,
                  PermissionCodes.PlnOrderList, PermissionCodes.PlnOrderManage,
                  PermissionCodes.PlnReservationList, PermissionCodes.PlnReservationManage,
                ]}
                match="any"
              />
            ),
            children: [
              {
                path: "pln/demands",
                element: (
                  <LazyPage>
                    <DemandsListPage />
                  </LazyPage>
                ),
              },
              {
                path: "pln/demands/new",
                element: (
                  <LazyPage>
                    <DemandsListPage />
                  </LazyPage>
                ),
              },
              {
                path: "pln/demands/:demandNo",
                element: (
                  <LazyPage>
                    <DemandDetailPage />
                  </LazyPage>
                ),
              },
              {
                path: "pln/orders",
                element: (
                  <LazyPage>
                    <ProductionOrdersListPage />
                  </LazyPage>
                ),
              },
              {
                path: "pln/orders/new",
                element: (
                  <LazyPage>
                    <ProductionOrdersListPage />
                  </LazyPage>
                ),
              },
              {
                path: "pln/orders/:orderNo/reservations",
                element: (
                  <LazyPage>
                    <MoReservationsPage />
                  </LazyPage>
                ),
              },
              {
                path: "pln/orders/:orderNo",
                element: (
                  <LazyPage>
                    <ProductionOrderDetailPage />
                  </LazyPage>
                ),
              },
              {
                path: "pln/reservations",
                element: (
                  <LazyPage>
                    <ReservationsHubPage />
                  </LazyPage>
                ),
              },
            ],
          },
];
